import React from "react";
import { format } from "date-fns";
import { X } from "lucide-react";

const IndentDetails = ({ indent, onClose }) => {
  if (!indent) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden">
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-xl font-semibold">Indent Details</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-4 overflow-y-auto max-h-[calc(90vh-8rem)]">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div>
              <h3 className="text-sm font-medium text-gray-500">Indent No</h3>
              <p className="mt-1">{indent.IndentNo}</p>
            </div>
            <div>
              <h3 className="text-sm font-medium text-gray-500">Project</h3>
              <p className="mt-1">{indent.ProjectName}</p>
            </div>
            <div>
              <h3 className="text-sm font-medium text-gray-500">Created By</h3>
              <p className="mt-1">{indent.CreatedByName}</p>
            </div>
            <div>
              <h3 className="text-sm font-medium text-gray-500">Created Date</h3>
              <p className="mt-1">{format(new Date(indent.CreatedDate), "dd/MM/yyyy")}</p>
            </div>
          </div>

          <div className="mb-6">
            <h3 className="text-lg font-medium mb-2">Items</h3>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Item Name</th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Quantity</th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Received</th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Remaining</th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Due Date</th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {indent.items?.map((item, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-900">{item.ItemName}</td>
                      <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">{item.Quantity}</td>
                      <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">{item.QuantityReceived || 0}</td>
                      <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                        {item.Quantity - (item.QuantityReceived || 0)}
                      </td>
                      <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                        {item.DueDate ? format(new Date(item.DueDate), "dd/MM/yyyy") : "N/A"}
                      </td>
                      <td className="px-4 py-2 whitespace-nowrap text-sm">
                        <span className={`px-2 py-1 rounded-full text-xs ${
                          item.QuantityReceived === item.Quantity
                            ? "bg-green-100 text-green-800"
                            : item.QuantityReceived > 0
                            ? "bg-yellow-100 text-yellow-800"
                            : "bg-red-100 text-red-800"
                        }`}>
                          {item.QuantityReceived === item.Quantity
                            ? "Completed"
                            : item.QuantityReceived > 0
                            ? "Partial"
                            : "Pending"}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {indent.Remarks && (
            <div>
              <h3 className="text-lg font-medium mb-2">Remarks</h3>
              <p className="text-gray-700">{indent.Remarks}</p>
            </div>
          )}
        </div>

        <div className="border-t p-4 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default IndentDetails; 